import { render } from "./ButtonContent.vue?vue&type=template&id=2b5b072e&scoped=true"
import script from "./ButtonContent.vue?vue&type=script&lang=js"
export * from "./ButtonContent.vue?vue&type=script&lang=js"

import "./ButtonContent.vue?vue&type=style&index=0&id=2b5b072e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5b072e"]])

export default __exports__